<template>
  <!-- 征集作品展播 -->
  <div class="collection">
    <div class="line" v-show="excellentTitle.length > 0"></div>
    <div class="show-box show-Title" id="excellentTitle" v-if="excellentTitle.length > 0">
      <router-link tag="a"
                   :to="{name:'list_video',params: {id: detailsTxte.id,init: 1}}"
                   style="text-decoration: none">
        <h5 class="show-tit" v-if="detailsTxte.playbill">征集作品展播
          <a href="javascript:void(0);" class="show-linkmore">更多</a>
        </h5>
      </router-link>
      <div v-for="(e,m) in excellentTitle">
        <div class="show-sl-tit" v-if="imgTable[m] && imgTable[m].length && numbers[m] > 0">
          <i class="icon-plt"></i>{{excellentTitle[m]}}
        </div>

        <!-- Swiper -->
        <div class="swiper-container show-work-swiper1 show-work"
             v-if="excellentStyle[m] == 2 && imgTable[m] && imgTable[m].length && numbers[m] > 0"
             style="padding-bottom: 10px">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-if="numbers" v-for="(v,ind) in numbers[m]">
              <ul class="show-list">
                <li v-for="(val,i) in 2">
                  <router-link tag="a" v-if="imgTable[m][ind*2+i]"
                               :to="{name:'VideoName',params: {id:imgTable[m][ind*2+i].activity_id,uuid: imgTable[m][ind*2+i].file_id,type:imgTable[m][ind*2+i].file_type}}">
                    <div class="pic-box">
                      <img v-if="imgTable[m][ind*2+i]" :src="(imgTable[m].latest?imgTable[m][ind*2+i].file.thumb_url:imgTable[m][ind*2+i].recommend_image)+'?p=3&o=2&w=350&h=197'" alt=""/>
                      <i class="icon-time">{{imgTable[m][ind*2+i].file.time_span|formatSeconds}}</i>
                    </div>
                    <p>{{imgTable[m][ind*2+i].file.title}}</p>

                    <div class="vode-user" v-if="imgTable[m][ind*2+i].nickname">
                      <i class="icon-mine" v-if="imgTable[m][ind*2+i].user"><img
                        :src="imgTable[m][ind*2+i].user.face_url" alt=""/></i>{{imgTable[m][ind*2+i].nickname,12|ellipsis}}
                    </div>
                    <div class="vode-user" v-else>
                      <i class="icon-mine" v-if="imgTable[m][ind*2+i].user"><img
                        :src="imgTable[m][ind*2+i].user.face_url" alt=""/></i>{{imgTable[m][ind*2+i].user.nick_name,12|ellipsis}}
                    </div>
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- Add Pagination -->
        <div class="detail-highlights"
             v-if="excellentStyle[m] == 1 && imgTable[m] && imgTable[m].length && numbers[m] > 0">
          <ul>
            <!-- <li class="clearfix" v-for="(item,val) in imgTable[m]" v-if="val < excellentMost[m]" v-show="val < 10"> -->
            <li class="clearfix" v-for="(item,val) in imgTable[m]">

              <div class="pic-boxs">
                <router-link tag="div"
                             :to="{name:'VideoName',params: {id:item.activity_id,uuid: item.file_id,type:item.file_type}}">
                  <img v-lazy="(imgTable[m].latest?item.file.thumb_url:item.recommend_image)+'?p=3&o=2&w=710&h=399'" alt=""/>
                </router-link>
                <i class="icon-time">{{item.file.time_span|formatSeconds}}</i>
              </div>
              <p>{{item.file.title,20|ellipsis}}</p>

              <div class="vode-user vode-detail" v-if="item.nickname">
                <i class="icon-mine" v-if="item.user"><img v-lazy="item.user.face_url" alt=""/></i>{{item.nickname,25|ellipsis}}
              </div>
              <div class="vode-user vode-detail" v-else>
                <i class="icon-mine" v-if="item.user"><img v-lazy="item.user.face_url" alt=""/></i>{{item.user.nick_name,25|ellipsis}}
              </div>
              <!--@click="vodeShare('video',item.activity_id,item.uuid,item.title,item.thumb_path)"-->
              <div class="vode-share">
                <img v-lazy="globalUrl + 'static/dist/img/da.png'" alt=""/>
              </div>
            </li>
          </ul>
         <!--  <div v-if="imgTable[m].length > 10" class="highlights-More"
               @click="more(m,imgTable[m].length,excellentMost[m])"><span></span>点击加载更多
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "collection",
    props: [
      "detailsTxte",
      "twoNumbers",
      "globalUrl"
    ],
    data() {
      return {
        excellentTitle: [], // 优秀作品title---
        excellent: '',     // 优秀作品
        excellentStyle: [],// 是否单双列
        excellentMore: [], // 显示多少条
        excellentMost: [], // 最多显示几条
        excellentName: '', // 优秀作品数量/2
        numbers: [],       // 最新上传数量/2
        imgTable: [],      // 最新上传
      }
    },
    methods: {
      // 操作按钮事件
      // 作品集锦显示个数
      // 当前 总数  最多显示个数
      more(index, all, max) {
        var that = this
        $('.detail-highlights').eq(index).find('li').show();
        $('.highlights-More').eq(index).hide();
      },
    },
    created: function () {
      var that = this;
      var pageConfig = that.detailsTxte.page_config;
      var id = this.$route.params.id;
      // 视频展示
      if (pageConfig) {
        // debugger;
        var latest = pageConfig.upload && pageConfig.upload[0];//最新上传
        var vied = pageConfig.video;

        if(latest && latest.is_show == 1){
           latest.isLate = true;///最新上传模块标记
            vied.push(latest)//
        }
        if (vied.length > 0) {
          dealvds(vied)
        }
      }
      function dealvds(vied){
        var t = 0;
        var imgArr= [];
        var numArr = [];
        vied = vied.filter((item,i)=>{
          return item.is_show == 1
        })
        //循环获取分类视频
        for (var i = 0; i < vied.length; i++) {
          //使用闭包保存变量，保证请求数据顺序
          (function(idx){
            var url, curTit = '',isLatest= false;
            // 作品集锦
            var pagesize = '';

            // if (vied && vied[i].is_show == 1) {

              // 默认展示多少条
              if (vied[i].count == 'twenty'||vied[i].count == '20') {
                pagesize = 20;
                that.excellentMost.push(20)
              } else {
                pagesize = 10;
                that.excellentMost.push(10)
              }
              // 判断是否单行
              if (vied[i].style == 'one_line') {
                that.excellentStyle.push(1)
              } else {
                that.excellentStyle.push(2)
              }
              /*   console.log(that.excellentStyle) */
              // 默认单排显示三个--展示更多展示剩余数量
              that.excellentMore.push(3);
              that.excellentTitle.push(vied[i].title);
              var indexvideo = {
                type: 1,
                activity_id: id,
                pagesize: pagesize,
                page: 1,
                key: vied[i].id,
                is_recommend: 1,
                version: 2,
                order: vied[i].order
              };

              //判断是否是最新上传模块
              curTit = vied[i].isLate;
              if(curTit){
                url = API.VideoLatest;//请求latest
                isLatest = true;
              }else{
                 url = API.VideoModel;//请求recommend
                isLatest = false;
              }
              that.$http.get(url, {params: indexvideo})
                .then(function (res) {
                  if (res.code == 0) {
                    //res.data = res.data.filter(function(item,i){return item.file&&item.file.time_span > 4})
                    numArr[idx] = (Math.floor(res.data.length / 2));
                    that.numbers = [...numArr];
                    t += Math.floor(res.data.length / 2);
                    imgArr[idx]= res.data;
                    if(isLatest){
                      imgArr[idx].latest = true;
                    }
                    that.imgTable = [...imgArr];
                    // that.$forceUpdate();
                    that.$nextTick(function () {
                      new Swiper('.show-work-swiper1', {
                        pagination: '.swiper-pagination1',
                        autoplay: 4000,
                        loop: true
                      });
                      // 图片比例
                      var picWimg = $('.pic-box').width();
                      var picHimg = Math.ceil($('.pic-box').width() / 16 * 9);
                      $('.pic-box img').css({width: picWimg, height: picHimg, visibility: 'visible'});
                      var picWimgs = $('.pic-boxs').width();
                      var picHimgs = Math.ceil($('.pic-boxs').width() / 16 * 9);
                      $('.pic-boxs img').css({width: picWimgs, height: picHimgs, visibility: 'visible'});
                    });

                    if (t >= 1) {
                      $('.show-Title').show()
                    } else {
                      $('.show-Title').prev().hide()
                      $('.show-Title').hide()
                    }
                  } else {
                    console.log('作品集锦-请求数据信息出错')
                    $('.show-Title').hide()
                  }
                });
            // }
          }(i))

        }

      }
    },
    mounted: function () {
      // 操作DOM
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/detailtmplate/collection.vue